import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import JavaScriptCodeEditorTerminal from "./Terminal/JavaScriptCodeEditorTerminal";
import AboutUs2 from "./AboutUs/AboutUs2";
import "./App.css";
import Footer from "./footer/Footer";
import NavBar from "./NavBar/NavBar";
import SocialMediaBar from "./social_media_bar/SocialMediaBar";
import AllCoursesPage from "./AllCoursesPage/AllCoursesPage";
import Contact from "./contact/Contact";
import HomePage from "./HomePage/HomePage";
import Tutorial from "./tutorial/Tutorial";
import Loader from "./Loader"; // ✅ Import Loader
import PythonCodeEditorTerminal from "./Terminal/PythonCodeEditorTerminal";
import JavaCodeEditorTerminal from "./Terminal/Java/JavaCodeEditorTerminal";
import CppCodeEditorTerminal from "./Terminal/CppCodeEditorTerminal";
import CProgrammingCodeEditorTerminal from "./Terminal/CProgrammingCodeEditorTerminal";
import HTMLCSSJavaScriptCodeEditorTerminal from "./Terminal/HTMLCSSJavaScriptCodeEditorTerminal";
import ReactCodeEditorTerminal from "./Terminal/ReactCodeEditorTerminal";

function App() {
  const [loading, setLoading] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Step 1: Show loader for 3s
    const timer1 = setTimeout(() => {
      setFadeOut(true); // start fade-out
    }, 2500);

    // Step 2: Remove loader after fade
    const timer2 = setTimeout(() => {
      setLoading(false);
    }, 3500);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  if (loading) {
    return <Loader fadeOut={fadeOut} />;
  }

  return (
    <div>
      <SocialMediaBar />
      <NavBar />
      <div className="App-contaiiner">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/all-courses" element={<AllCoursesPage />} />
          <Route path="/about" element={<AboutUs2 />} />
          <Route path="/tutorial/*" element={<Tutorial />} />
          <Route path="/contact" element={<Contact />} />
          <Route
            path="/terminal/javascript"
            element={<JavaScriptCodeEditorTerminal />}
          />
          <Route
            path="/terminal/python"
            element={<PythonCodeEditorTerminal />}
          />
          <Route
            path="/terminal/htmlCss"
            element={<HTMLCSSJavaScriptCodeEditorTerminal />}
          />
          <Route path="/terminal/react" element={<ReactCodeEditorTerminal />} />
          <Route
            path="/editorHTML"
            element={<HTMLCSSJavaScriptCodeEditorTerminal />}
          />
          <Route path="/terminal/javaL" element={<JavaCodeEditorTerminal />} />
          <Route path="/terminal/cpp" element={<CppCodeEditorTerminal />} />
          <Route
            path="/terminal/c"
            element={<CProgrammingCodeEditorTerminal />}
          />
          <Route path="/editorJS" element={<JavaScriptCodeEditorTerminal />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default App;
